import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "data-type"]
const _hoisted_2 = ["for"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["id", "type", "name", "data-active-element-match-name"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "error-msg" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["MarketoInputSyncWrapper"], {
    modelValue: $setup.proxyModelValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.proxyModelValue) = $event)),
    "marketo-input-name": $props.formInputMeta.marketoName
  }, {
    default: _withCtx(() => [
      ($setup.consentRequired)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: 'parent_' + $props.formInputMeta.marketoName,
            class: _normalizeClass(["parent-field-wrpr", $setup.parentWrapperClasses]),
            "data-type": $props.formInputMeta.type
          }, [
            _createElementVNode("label", {
              class: "eclipse-label",
              for: $props.formInputMeta.name
            }, [
              _createElementVNode("p", null, [
                _createVNode($setup["TranslationComponent"], {
                  translation: $setup.translate($setup.FormLabelKeysEnum.eclipse_Email_Opt_In__c, { ns: $setup.TranslationNamespaceEnum.formLabels })
                }, {
                  "privacy-policy-link-slot": _withCtx(() => [
                    _createElementVNode("a", {
                      class: "privacy-href",
                      href: `${$setup.localeUrlPrefix}/privacy/`,
                      target: "_blank"
                    }, _toDisplayString($setup.translate($setup.FormLabelKeysEnum.privacyPolicyLinkText, { ns: $setup.TranslationNamespaceEnum.formLabels })), 9 /* TEXT, PROPS */, _hoisted_3)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["translation"]),
                _withDirectives(_createElementVNode("input", {
                  id: $props.formInputMeta.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.proxyModelValue) = $event)),
                  type: $props.formInputMeta.type,
                  name: $props.formInputMeta.name,
                  "data-active-element-match-name": $props.formInputMeta.marketoName
                }, null, 8 /* PROPS */, _hoisted_4), [
                  [_vModelDynamic, $setup.proxyModelValue]
                ]),
                _hoisted_5
              ])
            ], 8 /* PROPS */, _hoisted_2),
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "error", {}, () => [
                _createTextVNode(" translated error here ")
              ])
            ])
          ], 10 /* CLASS, PROPS */, _hoisted_1))
        : (_openBlock(), _createBlock($setup["privacyStatement"], { key: 1 }))
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["modelValue", "marketo-input-name"]))
}